import { isChainHeadSelector, isChainSubordinateSelector, isIndependentSelector } from 'selectors';
import _ from 'lodash';

const mapStateToThis = ({ dictionary, session }) => {
  const { locale } = session;
  const isIndependent = isIndependentSelector({ session });
  const isChainHead = isChainHeadSelector({ session });
  const isChainSubordinate = isChainSubordinateSelector({ session });

  const terms = dictionary.terms[locale];

  return {
    terms,
    isIndependent,
    isChainHead,
    isChainSubordinate,
  };
};

// eslint-disable-next-line no-undef
@Inject('gettextCatalog', '$ngRedux')
class ManageInventoryTableService {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
    this.definitions = {
      ORDER_NO: {
        text: this.gettextCatalog.getString('Order No.'),
        field: 'orderNumber',
        sortable: true,
      },
      ORDER_STATUS: {
        text: this.gettextCatalog.getString('Order Status'),
        field: 'statusDesc',
        sortable: true,
      },
      ORDER_ISSUED_DATE: {
        /// {{ issued }} is Lottery term using to determine Pack status.
        text: this.gettextCatalog.getString('{{ issued }}', { issued: this.terms.ISSUED.singular }),
        field: 'orderIssuedDate',
        sortable: true,
      },
      ORDER_CONFIRMED_DATE: {
        /// {{ confirmed }} is Lottery term using to determine Pack status.
        text: this.gettextCatalog.getString('{{ confirmed }}', { confirmed: this.terms.CONFIRMED.singular }),
        field: 'orderConfirmedDate',
        sortable: true,
      },
      ORDER_TYPE: {
        /// {{ issuedMethod }} is Lottery term using to determine issued method.
        text: this.gettextCatalog.getString('{{ issuedMethod }}', { issuedMethod: _.get(this.terms, ['ISSUED_METHOD', 'singular']) }),
        field: 'orderType',
        sortable: true,
      },
      ORDER_GROSS_VALUE: {
        text: this.gettextCatalog.getString('Total {{ packs }} Value', {
          packs: this.terms.PACK.plural,
        }),
        field: 'detailGrossValue',
        sortable: true,
        textAlignment: 'text-right',
      },
      TRACKING_NO: {
        text: this.gettextCatalog.getString('Tracking No.'),
        field: 'prefixedTrackingNumber',
        sortable: true,
        textAlignment: 'text-right',
      },
      STORE_NO: {
        text: this.gettextCatalog.getString('Store No.'),
        field: 'storeNum',
        sortable: false,
      },
      RETAILER_NO: {
        text: this.gettextCatalog.getString('Retailer No.'),
        field: 'retailerId',
        sortable: false,
      },
    };
  }

  getHeaders() {
    const {
      ORDER_NO,
      ORDER_STATUS,
      ORDER_ISSUED_DATE,
      ORDER_CONFIRMED_DATE,
      ORDER_TYPE,
      ORDER_GROSS_VALUE,
      TRACKING_NO,
      STORE_NO,
      RETAILER_NO,
    } = this.definitions;

    if (this.isIndependent || this.isChainSubordinate) {
      return [ORDER_NO, ORDER_STATUS, ORDER_ISSUED_DATE, ORDER_CONFIRMED_DATE, ORDER_TYPE, TRACKING_NO, ORDER_GROSS_VALUE];
    }

    if (this.isChainHead) {
      return [
        STORE_NO,
        RETAILER_NO,
        ORDER_NO,
        ORDER_STATUS,
        ORDER_ISSUED_DATE,
        ORDER_CONFIRMED_DATE,
        ORDER_TYPE,
        TRACKING_NO,
        ORDER_GROSS_VALUE,
      ];
    }

    console.error(`MANAGE INVENTORY TABLE SERVICE: table definition does not exist for given retailer type`);
    return [];
  }
}

export default ManageInventoryTableService;



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/manage-inventory-table-service.js